import   React,
       { useEffect,
         useState,
         useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography,
         Container } from '@material-ui/core';
import { Button,
         ButtonGroup,
         Slider,
         TextField,
         } from '@material-ui/core';

import { GATag, 
         Stack,
         setOffsetHeight,
         setOffsetWidth } from "../util/tools";
import { appContext } from "./index";
import { GoBack,
         Avatar,
         Candy,
         Mode } from "./Util";
import { recordOutput,
         } from "../util/videoUtil";
import { INFO,
         REACT_STATES,
         console_log,
         CONSTS,
         initCONES,
         TIMES, } from '../util/object';
import { UTIL_useStyles,
         Spacer,
        } from "./Util";  
import { NOW } from "../util/util";  
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight,
         faAngleLeft,
         faCrown,
         faEnvelope } from '@fortawesome/free-solid-svg-icons';     //icons: https://fontawesome.com/icons
import Webcam from "./Webcam";
import { PortableWifiOff } from '@material-ui/icons';


const result_useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '100vh',
        maxWidth: '100vw',
        marginTop: '0vh',
        padding: "0",
        //backgroundColor:'#44ffff',
        //display: 'none',
    },

    expand_container: {
        padding: '0',
        transform: "translate(-20px, 100%)",
        position: 'absolute',
        zIndex: '350',
    },
    expand_icon: {
        fontSize: "1.7em",
        padding: '5px',
        margin: '0',
        color: '#b2afaf',
        height: '40px',
        width: '100%',
        borderRadius: '50%',
        backgroundColor: '#385c7b',
        opacity: '0.8',
    },
    result_webcam_container: {
        height: 'auto',     // '6vh',
        width: 'auto',
        padding: '0',
        margin: '0',
    },
    control_row_container: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        padding: '0',
        margin: '5px 0 0 0',
        alignItems: 'center',
        width: '100%',
    },
    spacer_container: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        padding: '0',
        margin: '0',
        alignItems: 'center',
        width: '100%',
        height: '80px',
    },
    mode_group: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        JustifyItems: 'space-between',
        height: '20px',     // '6vh',
        width: '80%',
        minWidth: '140px',
        maxWidth: '160px',
        minHeight: '30px',
        margin: '20px auto',
        //minWidth: '160px',
        //marginBottom: '2.5vh',
        //marginTop: '0.7vh',
        //borderRadius: '10px',

    },
    dev_btn_container: {
        display: 'flex',
        position: "absolute",
        right: '0',
        bottom: '50px',
        height: 'auto',
        width: '100%',
        padding: '8px 0',
        zIndex: '300',
        background: '#f2f2f5aa',
        flexDirection: 'column',
    },
    mode_button: {
		fontSize: '0.8rem',
        height: '100%',     
        color: 'white',
        border: '0',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '380',
        backgroundColor: '#4f59a6f2',     // Dark Cornflower Blue
        //width: '5vw',
        //boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
    },
    control_button: {
        "&:hover": {
            color: 'yellow',
            backgroundColor: '#3b58c1',
        },
		fontSize: '1.0rem',
        height: '45px',     //'6vh',
        width: '10vw',
        minWidth: '160px',
        minHeight: '40px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '2.5vh',
        marginTop: '5px',       // '0.7vh',
        padding: '10px',
        borderRadius: '10px',
        border: '0',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '380',
        color: 'white',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
        //backgroundColor: 'rgba(20, 70, 162, 0.9)',
    },
    hide_button: {
        "&:hover": {
            color: 'yellow',
            backgroundColor: '#3b58c1',
        },
		fontSize: '0.9rem',
        height: '40px',     //'6vh',
        width: '10vw',
        minWidth: '160px',
        minHeight: '40px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '5px',
        marginTop: '5px',       // '0.7vh',
        padding: '10px',
        borderRadius: '10px',
        border: '0',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '380',
        color: 'white',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
        //backgroundColor: 'rgba(20, 70, 162, 0.9)',
    },
    results_container: {
        display: "flex",
        padding: '0',
        margin: '0 auto 0 auto',     // 50px
        minWidth: "160px",
        width: "200px",     //"100%",
        height: "calc(100vh - 50px)",       // "auto",
        flexDirection: "row",
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        alignContent: 'space-between',      // does something
        justifyContent: 'center',
        zIndex: '100',
        overflow: "auto",
        //background: '#5c5b5b',      //'white',
        //paddingTop: CONSTS.GOBACK_BAR_HEIGHT+"px",      // do this at lower level
        //marginLeft: 'auto',
        //marginRight: 'auto',
        //maxHeight: "600px", 
        //maxWidth: "200px",      // adjust video box to this
        //alignSelf: 'center',
        //transform: 'translateY(-50px)',
    },
    aresults_container: {
        display: "flex",
        position: 'relative',
        padding: '0',
        margin: '0 auto 0 auto',     // 50px
        minWidth: "160px",      // 50px
        width: "200px",
        height: '100%',     //"calc(100% - 70px)",
        flexDirection: "column",
        //flexWrap: 'wrap',
        //alignItems: 'flex-end',
        //alignContent: 'flex-start',     //space-between',      // does something
        //justifyContent: 'center',     // 'center',
        //zIndex: '100',
        //overflow: "auto",
        //background: '#5c5b5b',
        //paddingTop: CONSTS.GOBACK_BAR_HEIGHT+"px",      // do this at lower level
        //marginLeft: 'auto',
        //marginRight: 'auto',
        //maxHeight: "600px", 
    },
    video_list_container: {
        display: 'flex',
        width: '100%',
        height: 'calc(100% - 110px)',
        overflow: "auto",
        background: '#5c5b5b',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        alignContent: 'flex-start',     //space-between',      // does something
        justifyContent: 'center',     // 'center',
        //padding: '3px 0',
        //position: "absolute",
        //bottom: '0',
        //right: '0',
        //zIndex: '300',
        //background: '#f2f2f561',
    },
    drill_btn_container: {
        display: 'flex',
        position: "absolute",
        left: '0',
        right: '0',
        bottom: '50px',
        height: 'auto',
        width: '100%',
        padding: '8px 0',
        zIndex: '300',
        background: '#f2f2f5aa',
        flexDirection: 'column',
    },
    notify_container: {
        display: "flex",
        flexDirection: "column",
        justifySelf: "flex-start",
        height: '20vh',
        width: '100%',
        paddingBottom: '5px',
        //background: 'pink'
    },
    record_container: {
        display: "flex",
        flexDirection: "row",
        justifySelf: "flex-start",
        width: '100%',
        //height: '20vh',
        //fontSize: '1.1rem',
		//fontWeight: '700',
        //textAlign: 'center',
        //color: '#447d52',
        //paddingTop: '25px',
        //background: 'pink'
    },
    record_text: {
        display: "flex",
        //flexDirection: "row",
        //alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.1rem',
		fontWeight: '700',
		lineHeight: '1.6',
        textAlign: 'center',
        color: '#ddd',      //'#447d52',
        paddingLeft: '10px',
    },
    mini_video_container: {
        //display: "none",
        display: "flex",
        padding: '0',
        margin: '0',
        width: "100%",
        height: "auto",
        flexDirection: "row",
        //alignItems: "flex-start",
        justifySelf: "flex-start",
        alignSelf: "center",        // in case not covering 100%
    },
    logo_icon: {
        marginRight: '2vw',
        minWidth: '5vw',   // 10vw
        minHeight: '3vh',
        alignSelf: "flex-start",
        width: "20%",
        color:'#d3d4f8',
    },
    perf_text: {
        display: "flex",
		fontSize: '1.3rem',
		fontWeight: '700',
		lineHeight: '1.6',
        color: 'red', 
        width: '50vw',
        flexDirection: "row",
        alignItems: 'center',
        justifyContent: 'center',
    },
    hi_perf_text: {
        display: "flex",
		fontSize: '1.3rem',
		fontWeight: '700',
		lineHeight: '1.6',
        color: 'red', 
        width: '50vw',
        flexDirection: "row",
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 0, 0.9)',

        //transition: "300ms all ease",
        //willChange: "background-color",
    },
    video_skim_container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    video_skip_container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    slider_label: {
        display: "flex",
		fontSize: '0.9rem',
		fontWeight: '700',
        color: '#808080',
        margin: '0',
        marginBottom: '-10px',
        alignItems: 'center',
        justifyContent: 'center',
        //backgroundColor: 'rgba(255, 0, 0, 0.9)',
    },
    control_slider: {
        display: "flex",
		fontSize: '1.0rem',
		fontWeight: '700',
        width: '80%',
        alignItems: 'center',
        justifyContent: 'center',
        //backgroundColor: 'rgba(0, 255, 0, 0.9)',
    },
    output_canvas: {
        //marginTop: "50px",
        //height: "0px",      // need to be reset later
        display: "block",
        width: "100%",
        position: "relative", 
        zIndex: 1, 
        //transform: 'scaleX(-1)',
    },
    vitem_container: {
        display: "flex",      // not needed at item level
        padding: '10px',
        margin: '0 0 5px 0',
        width: "160px",
        height: "60px",
        flexDirection: "column",       //"row",
        flexWrap: 'wrap',
        alignItems: "flex-start",
        textAlign: 'center',
        color: "white",
        borderColor: 'rgba(255,255,255,0)',
        borderRadius: '3px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.35) 0px 6px 12px -2px, rgba(0, 0, 0, 0.45) 0px 3px 7px -3px',
        //boxShadow: '0 10 20 0',
        //backgroundColor: 'rgba(71,95,130,0.6)',
        backgroundColor: '#2e5186e3',
        alignContent: 'spaceBetwen',
        fontSize: '0.65rem',
        zIndex: '150',              // catalog overlay
    },
    easter_container: {
        position: 'absolute',
        //left: '0',
        bottom: '0px',
        width: '60px',
        height: '40px',
        zIndex: '1000',
        //backgroundColor: 'red',
    },
    thumbnail: {
        height: '45px',
        paddiing: '0 10px 0 0',
        zIndex: '300',
        //bottom: '0px',
        //width: '60px',
        //backgroundColor: 'red',
    },
}))




const LearnResult = (props) => {
    const classes = result_useStyles();
    const Classes = UTIL_useStyles();
    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }
    const [ SpeedClass, setSpeedClass ] = useState(classes.perf_text);
    const [ ReactionDisplay, setReactionDisplay ] = useState("");
    const [ PReactionDisplay, setPReactionDisplay ] = useState("");
    const [ Recording, setRecording ] = useState(!INFO.record_mode);
    const [ SkimPosition, setSkimPosition ] = useState(0);
    const [ SkimPressed, setSkimPressed ] = useState(0);
    const [ SkipPosition, setSkipPosition ] = useState(0);
    const [ RecordLabel, setRecordLabel ] = useState("");
    const [ SpeedLabel, setSpeedLabel ] = useState("");
    const [ DrillSummary, setDrillSummary ] = useState([]);
    const [ Refresh, setRefresh ] = useState(0);
    const [ WebcamWidth, setWebcamWidth ] = useState(null);
    const [ WebcamHeight, setWebcamHeight ] = useState(null);
    const [ CanvasVideoWidth, setCanvasVideoWidth ] = useState(null);
    const [ CanvasVideoHeight, setCanvasVideoHeight ] = useState(null);
    const [ ShowGround, setShowGround ] = useState(true);
    const [ Show3D, setShow3D ] = useState(false);
    const [ ShowTripod, setShowTripod ] = useState(false);
    //const [ ShowExpand, setShowExpand ] = useState(false);
    //const [ SlowMo, setSlowMo ] = useState(false);

    useEffect(() => {
        //refreshOutput();     // kick off the refresh thread
        //handleRecordingMode(INFO.record_mode);
        console.log("LearnResult.167:   START RESULTS      perf=",INFO.perf_mode, "  game=",INFO.game_mode, " mock=",INFO.mock_mode, "  practice=",INFO.practice_mode, " ",props);

        setDrillSummary([{"field": "NONE", "value": "NONE", "timestamp": "NONE" }]);
        adjustResultScreen();
        setSkimPosition(0);
        setSkipPosition(0);

        window.addEventListener('resize', adjustResultScreen);
        window.addEventListener("orientationchange", adjustResultScreen);
        return function cleanup() {
            console.log("Results.193:   CLEANUP Result.....");
            window.removeEventListener('resize', adjustResultScreen);
            window.removeEventListener("orientationchange", adjustResultScreen);
        }
    }, [1]);

    useEffect(() => {
        console.log("webcam.426:   RESULT UPDATE WEBCAM DIM  wd=",INFO.webcam_owidth,"  ht=",INFO.webcam_oheight, " INFO.webcam_started=",props.WebcamStarted);
        setWebcamWidth(INFO.webcam_owidth);
        setWebcamHeight(INFO.webcam_oheight);
        setCanvasVideoWidth(INFO.webcam_owidth);      // <canvas id="output" > element
        setCanvasVideoHeight(INFO.webcam_oheight);
        adjustResultScreen();
    }, [props.ExpandIcon, ReactionDisplay, SpeedClass, SpeedLabel, RecordLabel, Recording]);

    useEffect(() => {
        //console.log("Result.329:   Display Refresh react=", Math.floor(TIMES.player_moving1));
        setReactionDisplay("");
        setPReactionDisplay("");
        //setShowExpand(false);
    }, [props.Stop]);

    useEffect(() => {
        console.log("result.216:   REFRESH  ",props.Refresh, " HandsFree=",props.HandsFree,"   Webcam_started=",props.WebcamStarted, "  aspect=",INFO.webcam_aspect,  " width=",INFO.webcam_owidth, " height=",INFO.webcam_oheight);
        adjustResultScreen();     // change to webcam mode
    }, [props.ButtonText, props.Title, props.WebcamStarted, props.Refresh]);

    useEffect(() => {
        //console.log("refresh.218:  HIDE Result_Bar=",props.Hide);
        adjustResultScreen();     // change to webcam mode
    }, [props.Hide]);

    useEffect(() => {
        checkSkimPressed(SkimPressed); 
    }, [SkimPressed, SkimPosition]);

    useEffect(() => {
        switch (props.Parent) {
            case "Challenge":
            case "Learn":
                setShowTripod(true);
                break;
            default:
                setShowTripod(false);
                break;
        }
    }, [props.Parent]);

    useEffect(() => {
        console.log("refresh.495:  <Result> HandsFree=",props.HandsFree);
    }, [ShowGround, props.HandsFree]);


    useEffect(() => {
        if ((ShowGround === true) && (INFO.cam_ground_mode === "tripod")) {
            handleCameraMode("tripod");
        }

        if ((ShowGround === false) && (INFO.cam_ground_mode === "ground")) {
            handleCameraMode("ground");
        }
    }, [INFO.cam_ground_mode]);


    useEffect(() => {
        if ((props.DrillSummary == undefined) || (props.DrillSummary == null)) {
            setDrillSummary([{"field": "NONE", "value": "NONE", "timestamp": "NONE" }]);
        } else {
            //console.log("result_refresh.510:  Drill Summary Changed =",JSON.stringify(props.DrillSummary));
            setDrillSummary(props.DrillSummary);
        }
        adjustResultScreen();     // change to webcam mode
    }, [props.DrillSummary]);


    useEffect(() => {
        //console.log("res_refresh.226:   SlowMo=",props.SlowMo);
        if(props.SlowMo == true) {
            setSpeedLabel("SLOW MO");
        } else {
            setSpeedLabel("NORMAL SPEED");
        }
    }, [props.SlowMo]);

    useEffect(() => {
        if(props.Recording == true) {
            setRecordLabel("RECORD ON");
            setRecording(true);        // for display in REACT
            INFO.record_mode = true;   // global state for actual ops
        } else {
            setRecordLabel("RECORD OFF");
            setRecording(false);
            INFO.record_mode = false;
        }
    }, [props.Recording]);

    const handleVideoSkimReset = (event, value) => {
        console.log("skim.490:  SKIM STOP DETECTED");
        setSkimPosition(0);
        setSkimPressed(0);
        INFO.vimeo_skim = 0;
    }

    const checkSkimPressed = (skip) => {
        //console.log("chk_skim.524:  props.SetVideoPosition=", props.SetVideoPosition);
        if ((props.SetVideoPosition === undefined) || (props.SetVideoPosition === null)) {
            return;
        }

        if ((INFO.vimeo_skim !== 0) && (SkimPosition !== 0)) {
            //console.log("skim.531:   .  .  .  .  .  activate skim=", skip, "  pressed=",SkimPressed, "  position=",SkimPosition);
            props.SetVideoPosition(null, INFO.vimeo_skim);

            setTimeout(()=>{
                checkSkimPressed(INFO.vimeo_skim);
            }, 300);
        } else {
            props.SetVideoPosition(null, 0);
        }
    }


    const handleVideoSkim = (event, value) => {
        console.log("skim.490:  START NEW SKIM   ", value);
        setSkimPosition(value);

        if(value === 0) {
            //console.log("skim.542:  start playing   value=", value);
            props.SetVideoPosition(null, null);     // start it to play
            return;
        }
        var skip = value * Math.abs(value);
        INFO.vimeo_skim = skip;
        setSkimPressed(skip);
        checkSkimPressed(skip);

    }

    const handleVideoPosition = (event, value) => {
        console.log("result.513:   VIDEO SKIP   to_value=", value);
        setSkipPosition(value);
        props.SetVideoPosition(value, null);
    }

    const valueLabelFormat = (value) => {
        return value.toString();
    }


    const handleStartButton = (value) => {
        INFO.disable_calibration = false;       // manual start always show calibration immediately
        props.RunAction();
    }


    const handleCameraMode = (value) => (event) => {
        console.log("result.450: ******  HANDLE Camera Mode =", value);
        switch(value){
            case "ground":
                setShowGround(true);
                INFO.cam_ground_mode = "ground";
                break;
            case "tripod":
                setShowGround(false);
                INFO.cam_ground_mode = "tripod";
                break;
        }
        initCONES("camera_mode.608."+value);
    }

    const handleShowResultDebug = (event) => {
        console.log("3d.513: ******  HANDLE SHOW Result DEBUG =", Show3D);

        if(Show3D === true) {
            setShow3D(false);
            INFO.show_3D = false;
        } else {
            setShow3D(true);
            INFO.show_3D = true;
        }
    }

    const handleRunExpand = (event) => {
        console.log("3d.513: ******  HANDLE SHOW Result DEBUG =", Show3D);
        props.RunExpand("result.622");
    }


                                       //position="relative" width="320" height="240" 
                                       //position="relative" width="360" height="270" 
                                       //position="relative" width={INFO.webcam_owidth} height={INFO.webcam_oheight} 

                                       /*style={{display: "none", width: "1px", height: "1px", visibilty: "hidden"}} />*/
                                /*
                                <video id="video" autoPlay muted={true} position="relative" width={WebcamWidth} height={WebcamHeight} 
                                       style={{display: "block", width: "1px", height: "1px"}} />
                                <canvas id="vcanvas" width={CanvasVideoWidth} height={CanvasVideoHeight} className={classes.prep_canvas} />
                                <canvas id="output" width={CanvasVideoWidth} height={CanvasVideoHeight} className={classes.output_canvas} />
                                <div id="target" className={Classes.target} />
                                */
        return (
            <React.Fragment>
                <Container id="results_container" className={classes.results_container}>
                    {(((props.Parent == "Learn") || (props.Parent == "Challenge")) && (props.WebcamStarted == true)) ?
                        <React.Fragment>
                            <Container id="mini_video_container" className={classes.mini_video_container}>
                                {props.ShowExpand && <Container id="exapand_button" className={classes.expand_container} onClick={handleRunExpand} >
                                    <FontAwesomeIcon id="expand_icon" className={classes.expand_icon}
                                        icon={props.ExpandIcon} style={{width: "40px"}} />
                                </Container>}

                                {Show3D && <div id="3d-gl-container" 
                                        style={{position: "absolute", 
                                        right: "0", top: '0',
                                        width: "300px", height: "300px", 
                                        margin: "0", padding: "0", 
                                        zIndex: "1000", background: "yellow"}}/>}

                                <Webcam ID={"resl_webcam_container"}
                                        Class={classes.result_webcam_container} 
                                        Style={{display: "block", width: "1px", height: "1px"}}
                                        WebcamWidth={WebcamWidth}
                                        WebcamHeight={ WebcamHeight }
                                        CanvasVideoWidth={CanvasVideoWidth} 
                                        CanvasVideoHeight={CanvasVideoHeight} />
                            </Container>

                        </React.Fragment>
                    :
                        <div id="notify_container" className={classes.notify_container}>
                            {(DrillSummary.length > 0) ?
                                DrillSummary.map((record, index) =>
                                    <Container key={"rec_"+index} id="record_container" className={classes.record_container}>
                                        <Candy id="level" Style={{height: "22px"}} Type={record.type} />
                                        <Avatar id="avatar8" Style={{height: "22px"}} Image={record.avatar} />
                                        <div key={"drill_"+index} id={"drill_"+index} className={classes.record_text}>
                                            {record.field.toString().toUpperCase()+": "+record.value}
                                        </div>
                                    </Container>
                                )
                            :
                                ""
                            }
                        </div>
                    }

                    {(false && (props.Parent == "Learn") && (props.SetVideoPosition) && (props.WebcamStarted == false)) && 
                    <React.Fragment>
                        <Container id="video skim_container" className={classes.video_skim_container}>
                            <Typography id="non-linear-slider" className={classes.slider_label} gutterBottom>
                                SEARCH
                            </Typography>
                            <Slider id="skim_slider" 
                            defaultValue={0}
                            value={SkimPosition}
                            track={false}
                            min={-2}
                            step={1}
                            max={2}
                            scale={(x) => x ** 2}
                            style={{padding: "0px", paddingTop: "12px"}}
                            valueLabelDisplay="auto"
                            getAriaValueText={valueLabelFormat} 
                            valueLabelFormat={valueLabelFormat}
                            aria-labelledby="non-linear-slider"
                            className={classes.control_slider} 
                            onChange={handleVideoSkim}
                            onMouseUp={handleVideoSkimReset}
                            onTouchEnd={handleVideoSkimReset}>
                            </Slider>
                        </Container>

                        <Container id="video_skip_container" className={classes.video_skim_container}>
                            <Typography id="non-linear-slider" className={classes.slider_label} gutterBottom>
                                VIDEO POSITION
                            </Typography>
                            <Slider id="skip_slider" 
                            defaultValue={0}
                            value={SkipPosition}
                            min={0}
                            step={1}
                            max={100}
                            //scale={(x) => x ** 10}
                            style={{padding: "0px", paddingTop: "12px"}}
                            valueLabelDisplay="auto"
                            getAriaValueText={valueLabelFormat} 
                            valueLabelFormat={valueLabelFormat}
                            aria-labelledby="non-linear-slider"
                            className={classes.control_slider} 
                            onChange={handleVideoPosition}>
                            </Slider> 
                        </Container>

                    </React.Fragment>}


                    {(props.HandsFree === false) && (props.WebcamStarted === false) && 
                    <React.Fragment>
                        {props.xRunRecord && <Mode Label={RecordLabel} Value={props.Recording} Handler={props.RunRecord} />}
                        {props.xRunSlowMo && <Mode Label={SpeedLabel} Value={props.SlowMo} Handler={props.RunSlowMo} />}

                        <Button id="show_graph" variant="contained" className={classes.control_button} onClick={props.ShowGraph}>
                            HISTORY
                        </Button>
                    </React.Fragment>}


                    {(props.HandsFree === false) && 
                    <Container id="control_row_container" className={classes.control_row_container}>
                        {false &&
                        <ButtonGroup variant="contained" aria-label="outlined primary button group" className={classes.mode_group} >
                            <Button className={classes.mode_button} disabled={ShowGround} onClick={handleCameraMode("ground")}> Gound</Button>
                            <Button className={classes.mode_button} disabled={!ShowGround} onClick={handleCameraMode("tripod")}> Tripod</Button>
                        </ButtonGroup>}

                        <Button id="start_btn" variant="contained" disabled={props.DisableRun} className={classes.control_button} onClick={handleStartButton}>
                            { props.ButtonText }
                        </Button>
                    </Container> }

                    <div id="result_spacer" className={classes.spacer_container} >
                        <div key="easter3" id="result_easter_right" className={classes.easter_container}  style={{right: '0px' }} onClick={handleStartButton}/>
                    </div>


                </Container>
            </React.Fragment>
        )
    }

                        /* (props.DisableRun == false) &&  */


    var vconsole_log = (false || (INFO.show_vconsole == true)) ? console_log : () => {};		// TRUE will show console.log
    function adjustResultScreen() {
        var root = document.getElementById('root');
        var display = document.getElementById('display_container');
        var results = document.getElementById('results_container');
        var shape = "", daspect = 0, aspect = 0, waspect = 0, rht = 0, rwd = 0, oht = 0, bht = 0, lht = 0;
        var wheight = 0, wwidth = 0, wvheight = 0, wvwidth = 0, has_video = true;
        var rheight = 0, rwidth = 0, topbars=1;
        var button = null, output = null, drill = null, webcam = null, video = null, video0 = null;
        var ht = Math.floor(display.offsetHeight);
        var wd = Math.floor(display.offsetWidth);
        var goback = 0;     // CONSTS.GOBACK_BAR_HEIGHT;
        daspect = (display == undefined) ? 2 : (wd / ht);       // display aspect, landscape or portraite
        topbars = (INFO.game_mode === true) ? 1 : 1;    // KLUDGE: NEED TO DO THIS RIGHT

        var practice_mode = (INFO.practice_mode || INFO.perf_mode) ? true : false;      // merge to use same code

        aspect = wd / ht;
        INFO.vertical_mode = false;
        if (aspect >= CONSTS.SCREEN_SUPER_WIDE_RATIO) {
            //shape = "super_wide";
            shape = "horizontal";
        } else if (aspect >= CONSTS.SCREEN_HORIZONTAL_RATIO) {
            shape = "horizontal";
        } else {
            INFO.vertical_mode = true;
            if (aspect <= CONSTS.SCREEN_SUPER_NARROW_RATIO) {
                //shape = "super_narrow";
                shape = "vertical";
            } else {
                shape = "vertical";
            }
        }

        //if ((INFO.practice_mode === true) && (INFO.game_mode === false)) 
        if (practice_mode === true) {
            drill = document.getElementById('drill_video_container');    // vimeo video output
            output = document.getElementById('drill_output');        // vimeo video output
            button = document.getElementById('start_btn');           // sidebar button
            webcam = document.getElementById('mini_video_container');   // sidebar webcam
            video0 = document.getElementById('video');   // sidebar webcam
            video = document.getElementById('output');   // sidebar webcam

            lht = (drill === null) ? 0 : drill.offsetHeight;        // vimeo video file
            oht = (output === null) ? 0 : output.offsetHeight;      // vimeo video
            bht = (button === null) ? 0 : button.clientHeight;      // action button
            rwd = (results === null) ? 0 : results.offsetWidth;     // result container
            rht = ht - lht - goback;        // calculated since result.ht may be on auto
            //rht = (results === null) ? 0 : results.offsetHeight;    // result container

            if (webcam !== null) {
                vconsole_log("radjust.263:  WEBCAM.1  I.aspect=",INFO.webcam_aspect, " v0.w=",video0.width, " v0.h=",video0.height, "  I.oht=",INFO.webcam_oheight, "  I.sidebar=",INFO.sidebar_width);
                if (video0 && video0.width) {
                    waspect = Math.floor(video0.width / video0.height * 1000)/ 1000;     // true webcam ratio
                } else {
                    waspect = CONSTS.WEBCAM_BASE_ASPECT;
                }


                //  - first figure out available height and calc width
                //  - if calc width is too wide, then use sidebar width and calc height
                //
                //if (daspect >= CONSTS.SCREEN_HORIZONTAL_RATIO) 
                if (INFO.vertical_mode === false) {
                    // horizontal mode - get height then calc width
                    wwidth = INFO.sidebar_width;
                    wheight = Math.floor(wwidth / waspect);     // shorter height
                    vconsole_log("radjust.308:  WEBCAM.2a  wwidth=",wwidth, " wheight=",wheight, " waspect=",waspect);
                    const VERT_KLUDGE = 5;
                    if (wheight > (ht - (bht + goback + VERT_KLUDGE))) {
                        // too tall, need to reduce the width to fit the height
                        wheight = Math.floor(ht - (bht + CONSTS.GOBACK_BAR_HEIGHT + VERT_KLUDGE)); // KLUDGE: added kludge pixel
                        wwidth = Math.floor(wheight * waspect);
                        vconsole_log("radjust.554:  WEBCAM.2b  TOO TALL!   wwidth=",wwidth, " wheight=",wheight, " waspect=",waspect);
                    }

                    wvheight = Math.floor(rht - (lht + (bht * 1) + CONSTS.GOBACK_BAR_HEIGHT)); // + 50);    // veritical mode: use result as max
                    vconsole_log("radjust.313:  HORZ WEBCAM.2c  wwd=",wwidth, "  wht=",wheight, "  waspect=",waspect.toFixed(3), "  dht=",ht, "  oht=",oht, "  bht=",bht, " sidebar=", INFO.sidebar_width);
                } else {
                    // vertical mode - get width then calc height
                    wwidth = Math.floor(wd);
                    wheight = Math.floor(wwidth / waspect);
                    vconsole_log("radjust.318:  VERT WEBCAM.3a  wwd=",wwidth, "  wht=",wheight, "  waspect=",waspect.toFixed(3), "  dht=",ht, "  oht=",oht, "  bht=",bht, " sidebar=", INFO.sidebar_width);
                    if (wheight > (rht - bht)) {
                        // 100% wide is too tall, need to cap the height and readjust width
                        wheight = rht - (2 * bht);      // rht need to calculated
                        wwidth = Math.floor(wheight * waspect);
                    }

                    vconsole_log("radjust.313:  HORZ WEBCAM.3b  wwd=",wwidth, "  wht=",wheight, "  waspect=",waspect.toFixed(3)," rht=",rht, "  ht=",ht, "  oht=",oht, "  bht=",bht, " sidebar=", INFO.sidebar_width);
                }
            } else {
                if (INFO.vertical_mode === false) {
                    // practice: horizontal mode
                    wheight = Math.floor(ht - (oht + (bht * 3)));
                    wwidth = Math.floor(wd - INFO.sidebar_width);
                    vconsole_log("radjust.578:  --------- PRACTICE NO-WEBCAM HORZ CALC -----------  oht=",oht, " bht=",bht, " lht=",lht);
                } else {
                    // practice: vertical mode
                    wheight = Math.floor(ht - lht);     // less vimeo
                    wwidth = Math.floor(wd);
                    vconsole_log("radjust.583:  --------- PRACTICE NO-WEBCAM VERT CALC -----------  oht=",oht, " bht=",bht, " lht=",lht);
                }
            }
        } else if (INFO.analyze_mode === true) {
            if (false) {
                output = document.getElementById('review_output');
                oht = (output === null) ? 0 : output.offsetHeight;      // vimeo video

                has_video = false;
                wheight = Math.floor(ht - (oht + (bht * 3)));
                wwidth = INFO.sidebar_width;
            }
            //wwidth = Math.floor(wd - INFO.sidebar_width);
            vconsole_log("radjust.626:  --------- ANALYSIS MODE -----------  wht=",wheight, " wwd=",wwidth, "  output=",(output !== null));
            return;

        } else if (INFO.game_mode === true) {
            output = document.getElementById('review_output');

            has_video = false;
            wheight = Math.floor(ht - (oht + (bht * 3)));
            wwidth = INFO.sidebar_width;
            vconsole_log("radjust.633:  --------- GAME MODE -----------  wht=",wheight, " wwd=",wwidth,"  output=",(output !== null));

        } else if (INFO.mock_mode === true) {
            //output = document.getElementById('review_output');
            //output = document.getElementById('drill_output0');        // vimeo video output
            output = document.getElementById('drill_output');        // vimeo video output

            has_video = true;
            wheight = Math.floor(ht - (oht + (bht * 3)));
            wwidth = INFO.sidebar_width;
            vconsole_log("radjust.633:  --------- SIMULATION MODE -----------  wht=",wheight, " wwd=",wwidth,"  output=",(output !== null));

        } else if (INFO.perf_mode === true) {
            output = document.getElementById('output');  // must have so we don't exit
            lht = (output === null) ? 0 : output.offsetHeight;      // vimeo video
            if (INFO.vertical_mode === false) {
                // perf: horizontal mode
                wheight = Math.floor(ht - (oht + (bht * 3)));
                wwidth = Math.floor(INFO.sidebar_width);
                //wwidth = Math.floor(wd - INFO.sidebar_width);
                vconsole_log("radjust.578:  --------- CHALLENGE HORZ CALC -----------  oht=",oht, " bht=",bht, " lht=",lht);
            } else {
                // perf: vertical mode
                wheight = Math.floor(ht - lht);     // less webcam
                wwidth = Math.floor(wd);
                vconsole_log("radjust.583:  --------- CHALLENGE VERT CALC -----------  oht=",oht, " bht=",bht, " lht=",lht);
            }
            /*
                //output = document.getElementById('output');
                //oht = (output === null) ? 0 : output.offsetHeight;      // webcam output

                //wheight = Math.floor(ht - (oht + (bht * 3)));
                wheight = Math.floor(ht - (lht + (bht * 3)));
                wwidth = Math.floor(wd - INFO.sidebar_width);
                //video = document.getElementById('video_container');
            vconsole_log("radjust.556:  --------- PERF CALC -----------  ht=",ht, " oht=",oht, " bht=",bht, "  lht=",lht);
            */
        } else {
            //console.log("radjust.571:  ******** ERROR: NOT SUPPORTED MODE! *********");
            return;
        }


        // Result Box
        //
        if (daspect >= CONSTS.SCREEN_HORIZONTAL_RATIO) {
            rheight = ht - CONSTS.GOBACK_BAR_HEIGHT;     // horizontal mode
        } else {
            //rheight = ht - lht;     // minus video output
            rheight = (ht - lht) - CONSTS.GOBACK_BAR_HEIGHT;     // vertical mode
        }

        vconsole_log("radjust.378:  RESULT HEIGHT   rheight=",rheight, "  ht=",ht, "  lht=", lht, " w.wd=",wwidth, " w.ht=",wheight, "  sidebar.w=",INFO.sidebar_width, "  sidebar.h=",INFO.sidebar_height);
        //vconsole_log("radjust.228: RESULT ENTRY ******  has_vid=",has_video," results=",results, " output=",output, " display=",display);
        if ((has_video) && ((results === null) || (output === null) || (display === null))) {
        //if ((has_video === false) || ((results === null) || (output === null) || (display === null))) 
            vconsole_log("radjust.635: SKIPPED BECAUSE.... has_vid=",has_video," results=",(results !== null), " output=",(output !== null), " display=",(display !== null));
            return;         // not ready yet
        }
        //vconsole_log("radjust.682:  ****** DIV STATUS... has_vid=",has_video," results=",(results !== null), " output=",(output !== null), " display=",(display !== null));

        //var rstyle = {...classes.results_container};    // make a copy
        switch (shape) {
            case "square":
                //results.style.maxWidth = "30vw";        // fit with output
                //results.style.width = display.offsetWidth;
                //results.style.height = display.offsetHeight - output.offsetHeight;
                results.style.maxWidth = INFO.sidebar_width+"px";        // fit with output
                results.style.width = INFO.sidebar_width+"px";        // fit with output
                setOffsetWidth(results, display.offsetWidth);
                results.style.height = "calc(100% - "+CONSTS.GOBACK_BAR_HEIGHT+"px)";      // for webcam screen
                results.style.height = "100%";      // 70vh
                results.style.transform = "";       // must clear it
                if (waspect > 0) {
                    webcam.style.marginTop = "";
                }
                vconsole_log("radjust.217: SQUARE      d.ow=",display.offsetWidth, " d.oh=", display.offsetHeight, 
                            " o.ow=",output.offsetWidth, " o.oh=", output.offsetHeight, 
                            " r.w=",results.style.width, " r.h=", results.style.height,
                            " r.ow=",results.offsetWidth, "  r.oh=",results.offsetHeight,
                            " root.ow=",root.offsetWidth, "  root.oh=",root.offsetHeight);
                break;
            case "vertical":
                results.style.maxWidth = "100%";        // override to allow max use
                setOffsetWidth(results, display.offsetWidth);
                results.style.width = "100%";   // use the width ==>NOT WORKING?
                setOffsetHeight(results, (rheight));
                results.style.height = "auto";
                //results.style.height = rheight+"px";


                //setOffsetHeight(results, (wheight));
                //results.style.height = wheight+"px";
                //results.style.transform = "translateY(-"+(2 * CONSTS.GOBACK_BAR_HEIGHT)+"px)";
                //results.style.transform = "translateY(-"+(CONSTS.GOBACK_BAR_HEIGHT)+"px)";
                //results.style.height = display.offsetHeight - output.offsetHeight;
                if (waspect > 0) {
                    webcam.style.height = wheight+"px";
                    webcam.style.width = 'auto';        //wwidth+"px";
                    setOffsetHeight(webcam, wheight);
                    //webcam.style.marginTop = "-"+CONSTS.GOBACK_BAR_HEIGHT+"px";       // no need
                    video.style.height = wheight+"px";
                    video.style.width = 'auto';        //wwidth+"px";
                    video0.style.height = wheight+"px";
                    video0.style.width = 'auto';        //wwidth+"px";
                    vconsole_log("radjust.343: VERTICAL.WEBCAM   w.w=",webcam.style.width, "  w.h=",webcam.style.height, 
                                " w.asp=",waspect, " v.ow=",video.offsetWidth, " v.oh=", video.offsetHeight);
                }
                vconsole_log("radjust.283: VERTICAL      d.ow=",display.offsetWidth, " d.oh=", display.offsetHeight, 
                            " o.ow=",output.offsetWidth, " o.oh=", output.offsetHeight, 
                            " r.w=",results.style.width, " r.h=", results.style.height,
                            " r.ow=",results.offsetWidth, "  r.oh=",results.offsetHeight,
                            " root.ow=",root.offsetWidth, "  root.oh=",root.offsetHeight);
                break;
            case "super_narrow":
                results.style.maxWidth = "100%";        // override to allow max use
                results.style.width = "100%";   // use the width ==>NOT WORKING?
                setOffsetWidth(results, display.offsetWidth);
                //results.style.height = "auto";
                results.style.height = rheight+"px";
                //results.style.transform = "translateY(-"+(2 * CONSTS.GOBACK_BAR_HEIGHT)+"px)";
                //results.style.transform = "translateY(-"+(CONSTS.GOBACK_BAR_HEIGHT)+"px)";
                //results.style.height = display.offsetHeight - output.offsetHeight;
                if (waspect > 0) {
                    webcam.style.marginTop = "";
                    webcam.style.height = wheight+"px"; //wv
                    webcam.style.width = 'auto';        //wwidth+"px";
                    setOffsetHeight(webcam, wheight);
                    //webcam.style.width = 'auto';        //wwidth+"px";
                    //webcam.style.marginTop = "-"+CONSTS.GOBACK_BAR_HEIGHT+"px";       // no need
                    video.style.height = wheight+"px";
                    video.style.width = 'auto';        //wwidth+"px";
                    video0.style.height = wheight+"px";
                    video0.style.width = 'auto';        //wwidth+"px";
                    vconsole_log("radjust.420: VERTICAL_NARROW.WEBCAM   w.w=",webcam.style.width, "  w.h=",webcam.style.height, 
                                " w.asp=",waspect, " v.ow=",video.offsetWidth, " v.oh=", video.offsetHeight);
                }
                vconsole_log("radjust.349: SUPER-NARROW      d.ow=",display.offsetWidth, " d.oh=", display.offsetHeight, 
                            " o.ow=",output.offsetWidth, " o.oh=", output.offsetHeight, 
                            " r.w=",results.style.width, " r.h=", results.style.height,
                            " r.ow=",results.offsetWidth, "  r.oh=",results.offsetHeight,
                            " root.ow=",root.offsetWidth, "  root.oh=",root.offsetHeight, " waspect=",waspect);
                break;
            case "horizontal":
                results.style.maxWidth = INFO.sidebar_width+"px";        // fit with output
                //setOffsetWidth(results, (display.offsetWidth - output.offsetWidth));
                setOffsetWidth(results, INFO.sidebar_width);
                results.style.width = INFO.sidebar_width+"px";        // MUST: follow setOffsetWidth()!
                //results.style.height = "calc(100% - "+(topbars*CONSTS.GOBACK_BAR_HEIGHT)+"px)";      // for webcam screen
                setOffsetHeight(results, (display.offsetHeight - output.offsetHeight));
                results.style.height = "calc(100% - "+(topbars*CONSTS.GOBACK_BAR_HEIGHT)+"px)";      // for webcam screen
                results.style.transform = "";       // must clear it
                results.style.marginTop = CONSTS.GOBACK_BAR_HEIGHT+"px";
                //results.style.transform = "translateY(-"+(1 * CONSTS.GOBACK_BAR_HEIGHT)+"px)";
                if (waspect > 0) {
                    // height is the limiting factor, need to have space for button
                    //webcam.style.height = wheight+"px";
                    //webcam.style.width = 'auto';        //wwidth+"px";
                    setOffsetWidth(webcam, wwidth);
                    webcam.style.width = wwidth+"px";        //wwidth+"px";
                    setOffsetHeight(webcam, (wheight));
                    webcam.style.height = (wheight) +"px";
                    webcam.style.marginTop = "-"+CONSTS.GOBACK_BAR_HEIGHT+"px";
                    video.style.height = wheight+"px";
                    video.style.width = 'auto';        //wwidth+"px";
                    webcam.style.marginTop = "";
                    //video0.style.height = wheight+"px";
                    //video0.style.width = 'auto';        //wwidth+"px";
                }
                //results.style.width = "100%";
                //results.style.height = "calc(100% - 50px)";      // not needed for webcam screen
                //results.style.transform = "translateY("+ CONSTS.GOBACK_BAR_HEIGHT +"px)";
                //console.log("radjust.282: HORIZONTAL   RESULTS=",results.style);
                vconsole_log("radjust.238: HORIZONTAL      d.ow=",display.offsetWidth, " d.oh=", display.offsetHeight, 
                            " o.ow=",output.offsetWidth, " o.oh=", output.offsetHeight, 
                            " r.w=",results.style.width, " r.h=", results.style.height,
                            " r.ow=",results.offsetWidth, "  r.oh=",results.offsetHeight,
                            " root.ow=",root.offsetWidth, "  root.oh=",root.offsetHeight, 
                            " I.side=",INFO.sidebar_width, " wht=",wheight);
                break;
            case "super_wide":
                //results.style.maxWidth = "30vw";        // fit with output
                results.style.maxWidth = INFO.sidebar_width+"px";        // fit with output
                setOffsetWidth(results, (display.offsetWidth - output.offsetWidth));
                results.style.width = INFO.sidebar_width+"px";         // MUST: follow setOffsetWidth()!
                setOffsetHeight(results, (display.offsetHeight - output.offsetHeight));
                results.style.height = "calc(100% - "+(topbars*CONSTS.GOBACK_BAR_HEIGHT)+"px)";      // for webcam screen
                results.style.transform = "";
                results.style.marginTop = CONSTS.GOBACK_BAR_HEIGHT+"px";
                if (waspect > 0) {
                    //webcam.style.height = wheight+"px";
                    //webcam.style.width = '100%';        //wwidth+"px";
                    setOffsetWidth(webcam, wwidth);
                    webcam.style.width = wwidth+"px";        //wwidth+"px";
                    setOffsetHeight(webcam, (wheight));
                    webcam.style.height = (wheight) +"px";
                    webcam.style.marginTop = "";
                    //webcam.style.width = 'auto';        //wwidth+"px";
                    //webcam.style.marginTop = "-"+CONSTS.GOBACK_BAR_HEIGHT+"px";
                    //video.style.height = wheight+"px";
                    //video.style.width = 'auto';        //wwidth+"px";
                }
                //results.style.height = "100vh";      // for webcam screen
                vconsole_log("radjust.238: SUPER-WIDE      d.ow=",display.offsetWidth, " d.oh=", display.offsetHeight, 
                            " o.ow=",output.offsetWidth, " o.oh=", output.offsetHeight, 
                            " r.w=",results.style.width, " r.h=", results.style.height,
                            " r.ow=",results.offsetWidth, "  r.oh=",results.offsetHeight,
                            " root.ow=",root.offsetWidth, "  root.oh=",root.offsetHeight);
                break;
            }
        }



// Display performance output results
const Results = (props) => {
    const classes = result_useStyles();
    const Classes = UTIL_useStyles();
    const [ RecordText, setRecordText ] = useState("RECORD");
    const [ ShowDev, setShowDev ] = useState(null);
    const [ ShowVideoList, setShowVideoList ] = useState(true);
    const [ ExpandListText, setExpandListText ] = useState("HIDE");

    useEffect(() => {
        console.log("Result.867:  ###### START RESULT Display    parent=",props.Parent, " ",props);
        adjustResultScreen();
    }, [1]);

    useEffect(() => {
        //console.log("Result.872:   Display Refresh   hide=", props.Hide);
        adjustResultScreen();
    }, [props.Refresh]);

    useEffect(() => {
        //console.log("Result.1056:   Videos Refresh   Videos=", props.Videos.length, " ",props);
    }, [props.Videos, RecordText]);

    useEffect(() => {
    }, [ShowDev, ShowVideoList]);


    useEffect(() => {
            setShowDev(props.ShowDevButton);
            if (props.ShowDevButton === true) {
                setShowDev(true);
            } else {
                setShowDev(false);
            }
    }, [props.DevAnalyzeMode, props.ShowDevButton])


    const handleVideoSelect = item => event => {
        console.log("v_select.743:   Clicked on Video =", item);
        props.RunAction(item);     // pass everything up
    }
    

    const handleRecordAction = event => {
        if (INFO.record_running === false) {
            props.RecordAction();
            setRecordText("STOP RECORD");
        } else {
            props.RecordAction();
            setRecordText("RECORD");
        }
    }

    const handleDevAction = event => {
        console.log("v_select.1091:   Clicked on DevAction  recording=", INFO.record_running, " dev_ai_run=",INFO.dev_ai_running, " dev_recording=",INFO.dev_recording);
        if (INFO.record_running === false) {
            props.DevAction();
        } else {
            props.DevAction();
        }
    }


    const handleHideListAction = event => {
        console.log("v_hide.1168:   Clicked on Hide Video List  ShowVideoList=", ShowVideoList, " ExpandListText=",ExpandListText, " dev_recording=",INFO.dev_recording);
        if (ShowVideoList === true) {
            setShowVideoList(false);
            setExpandListText("SHOW");
        } else {
            setShowVideoList(true);
            setExpandListText("HIDE");
        }
    }




    // holds user videos for review
    //    - Show a list of items to click, the result is shown in <Learn>
    //    - Used by <Analyze>Used by <Analyze>
    //
    const VideoResults =  () => {
        //console.log("v_select.866:   SHOW REVIEW VIDEO LIST  props.Videos=", props.Videos);
        return (
            <React.Fragment>
                <Container id="results_container" className={classes.aresults_container}>
                    
                    <Button id="record_btn" variant="contained" 
                        className={classes.hide_button} onClick={handleHideListAction}>
                        { ExpandListText }
                    </Button>

                    {(ShowVideoList) &&
                    <React.Fragment>
                        <Container id="video_list_container" className={classes.video_list_container}>
                            {props.Videos.map( (item, index) => {
                                return (
                                    <Container key={"item_"+index} className={classes.vitem_container} onClick={handleVideoSelect(item)} >
                                        {item.title}
                                    {(item.type === "replay") ? <img id="drill_thumb" src={CONSTS.PREVIEW_ASSET_PATH+item.title} className={classes.thumbnail} /> : ""}
                                    </Container>
                                )}
                            )}
                            <Spacer Height={"220px"} Width={"100%"} />
                        </Container>

                        {ShowDev &&
                        <Container id="dev_btn_container" className={classes.dev_btn_container}>
                            <Button id="record_btn" variant="contained" disabled={props.DisableRun} 
                                className={classes.control_button} onClick={handleRecordAction}>
                                { RecordText }
                            </Button>
                            <Button id="process_btn" variant="contained" disabled={props.DisableRun} 
                                className={classes.control_button} onClick={handleDevAction}>
                                { props.ButtonText }
                            </Button> 
                        </Container>}
                    </React.Fragment>}

                </Container>

            </React.Fragment>
    ) }



                    //{(props.Parent === "VideoReview") && <VideoResult runVideo={props.RunAction} {...props} />}
    return (
        <React.Fragment>
            {(props.Hide === false) ?
                <React.Fragment>
                    {((props.Parent === "Challenge") || 
                      (props.Parent === "Learn") || 
                      (props.Parent === "Game") || 
                      (props.Parent === "Mock")) && <LearnResult {...props} />}

                    {(props.Parent === "VideoReview") && VideoResults() }
                </React.Fragment>
            :
               <div /> 
            }
        </React.Fragment>
    )
}



export default Results